import { render, staticRenderFns } from "./NavSubGroup.vue?vue&type=template&id=0f329d51&scoped=true&"
import script from "./NavSubGroup.vue?vue&type=script&lang=js&"
export * from "./NavSubGroup.vue?vue&type=script&lang=js&"
import style0 from "./NavSubGroup.vue?vue&type=style&index=0&id=0f329d51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f329d51",
  null
  
)

export default component.exports